import React, { ReactNode, useMemo } from "react"
import { openOverlay, useOverlayDispatch, useOverlayState } from "../../../shared/context/overlay"

import Footer from "../../../shared/components/layout/footer-v2"
import FooterMenu from "../../../shared/components/menu/footer-v2"
import Header from "../../../shared/components/layout/header"
import HeaderMenu from "../../../shared/components/menu/header-v2"
import Overlay from "../../../shared/components/overlay"
import Sitemap from "../../../shared/components/overlay/sitemap"
import { Translations } from "../../../shared/components/menu/locales"
import { findTranslation } from "../../../shared/utils/find-translation"
import { sitemapMenu } from "../../../shared/config/sitemap"
import { useAuthState } from "../../../shared/context/auth"
import { useIsApp } from "../../../hooks/use-in-app"
import { useLocalesState } from "../../../shared/context/locales"
import { useTranslation } from "react-i18next"

interface LayoutProps {
    children: ReactNode
    landingPage?: boolean
    hideShop?: boolean
    translations?: Translations
    path?: string
}

const Layout = ({ children, landingPage, translations, hideShop, path }: LayoutProps) => {
    const overlayDispatch = useOverlayDispatch()
    const { overlay } = useOverlayState()

    const { t } = useTranslation("translations")

    const { language, region } = useLocalesState()

    const { isPartner } = useAuthState()

    const isApp = useIsApp()

    const showSitemap = useMemo(
        () =>
            sitemapMenu
                .map(column => column.filter(item => findTranslation(item, language)))
                .some(column => column.length > 0),
        [language]
    )

    return (
        <>
            <div className="antialiased">
                {!isApp && (
                    <Header
                        configuration={{
                            account: !landingPage,
                            cart: !landingPage && region !== "TR" && region !== "CZ",
                            shop: !hideShop,
                            language: !landingPage && !isPartner,
                            logoLink: process.env.WEB_URL,
                        }}
                        menu={!landingPage && <HeaderMenu />}
                        translations={translations}
                    />
                )}
                <main id="main" className="mb-auto">
                    {children}
                </main>
                {!overlay && <Overlay />}
                {!isApp && (
                    <>
                        <Footer
                            configuration={{
                                language: !landingPage && !isPartner,
                                logoLink: process.env.WEB_URL,
                            }}
                            menu={<FooterMenu />}
                            sitemap={
                                showSitemap && (
                                    <button
                                        type="button"
                                        onClick={() => openOverlay(overlayDispatch, <Sitemap language={language} />)}
                                    >
                                        {t("footer_sitemap")}
                                    </button>
                                )
                            }
                            translations={translations}
                        />
                        {showSitemap && <Sitemap hidden language={language} />}
                    </>
                )}
                {overlay}
            </div>
        </>
    )
}

export default Layout
